import AssistantTextBubbleController from "./AssistantTextBubbleController.js";
import AssistantThinkingBubbleController from "./AssistantThinkingBubbleController.js";
import AssistantGeneratingBubbleController from "./AssistantGeneratingBubbleController.js";
import AssistantToolBubbleController from "./AssistantToolBubbleController.js";
import UserMessageBubbleController from "./UserMessageBubbleController.js";

export const assistantTextBubbleController = new AssistantTextBubbleController();
export const assistantThinkingBubbleController =
  new AssistantThinkingBubbleController();
export const assistantGeneratingBubbleController =
  new AssistantGeneratingBubbleController();
export const assistantToolBubbleController = new AssistantToolBubbleController();
export const userMessageBubbleController = new UserMessageBubbleController();
